<template>
  <!-- 打印模板设计 -->
  <div class="ff_print_tpl">
    <div class="td-header">
      <div class="tdh-left">
        <span class="tdhl-rect-icon" />
        <div class="tdhl-title" @click="goDesign">表单管理</div>
        <span class="su-icon-arrow tdhl-arrow-icon" />
        <span class="tdhl-subtitle">打印模板设计</span>
      </div>
      <div class="tdh-right" @click="goDesign">返回到表单管理</div>
    </div>
    <div ref="printMain" class="print-main">
      <div ref="pmHeader" class="pm-header">
        <div class="pmh-l">打印模板设计</div>
        <div class="pmh-r">
          <sw-switch
            v-model="tplParams.isDefault"
            style="margin-right: 20px"
            inactive-text="是否为默认模板"
          />
          <sw-button @click="goDesign">关闭</sw-button>
          <sw-button
            v-if="$route.query.type !== 'details'"
            :loading="saveLoading"
            type="primary"
            @click="saveTpl"
            >保存</sw-button
          >
        </div>
      </div>
      <div :style="{ height: pmcHeight }" class="pm-content" @mousedown="move">
        <div class="pmc-left" style="width: 230px; padding: 8px 12px">
          <sw-input
            ref="pmclFilter"
            v-model="filterConditionValue"
            placeholder="请输入筛选内容"
            prefix-icon="el-icon-search"
          />
          <ul :style="{ height: placeholderListHeight }" class="pmcl-list">
            <li
              v-for="(item, index) in placeholderFilterList"
              :key="index"
              class="pmcll-item"
            >
              {{ item.name }}
              <div
                class="pmclli-model"
                style="width: 176px; word-break: break-all"
              >
                {{ item.model }}
              </div>
            </li>
          </ul>
        </div>
        <div
          ref="pmCenter"
          class="pmc-center"
          style="flex: 1; position: relative"
        >
          <VueUhtmlWrap
            v-model="tplParams.editorValue"
            :config="ueditorConfig"
            :destroy="true"
            @ready="editorReady"
          />
        </div>
        <div ref="pmRight" class="pmc-right" style="width: 225px">
          <sw-input
            v-model="tplParams.name"
            :disabled="disabled"
            placeholder="请输入模板名称"
          >
            <template slot="prepend">名称</template>
          </sw-input>
          <div style="margin-top: 10px">
            <sw-switch
              v-model="tplParams.isFtl"
              inactive-text="是否为ftl打印"
            />
          </div>
          <div style="margin-top: 10px">
            <p style="color: #606266; font-size: 13px; margin: 0 0 5px">
              自定义名称：
            </p>
            <sw-input v-model="tplParams.templateName" clearable />
          </div>
          <div v-if="tplParams.isFtl" class="pmc-ftl">
            <el-upload
              ref="upload"
              :action="action"
              :headers="headers"
              :file-list="fileList"
              :on-preview="handleFileChange"
              :on-success="handleFileSuccess"
              :on-error="handleFileError"
              class="upload-demo"
            >
              <el-button size="small" type="primary">上传模板</el-button>
              <div slot="tip" class="el-upload__tip">允许上传任意类型文件</div>
            </el-upload>
            <el-input
              style="margin: 5px 0"
              size="mini"
              placeholder="默认为文件名"
              v-model="tplParams.downloadFileName"
            >
              <template slot="prepend">下载名称</template>
            </el-input>
          </div>
          <div style="font-size: 14px; color: #626f79; margin-top: 20px">
            签章部门选择：
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 8px;
            "
          >
            <el-radio v-model="tplParams.stype" label="handler"
              >审核人所在部门</el-radio
            >
            <el-radio v-model="tplParams.stype" label="dept">指定部门</el-radio>
          </div>
          <el-cascader
            :disabled="disabled || tplParams.stype === 'handler'"
            v-model="tplParams.departmentId"
            :options="departmentData"
            :show-all-levels="false"
            :props="{ value: 'id', label: 'ins_name', checkStrictly: true }"
            filterable
            style="margin: 8px 0"
          />
          <div style="text-align: right">
            <sw-button @click="resetSeal('')">复位</sw-button>
          </div>
          <div
            id="seal"
            :style="{
              cursor: mouseStatus === 'onmouseup' ? 'grab' : 'grabbing',
              backgroundImage: 'url(' + signImg + ')',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }"
          />
          <div
            id="seal-static"
            :style="{
              backgroundImage: 'url(' + signImg + ')',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }"
          />
          <div style="background: #e1e4e6; margin: 20px 0; height: 1px" />
          <div
            v-show="tplParams.sealInEditor"
            style="color: #626f79; font-size: 12px; margin: 16px 0"
          >
            签章中心相对于文档左上角位置:
            <div style="font-size: 14px; margin-top: 8px">
              x: {{ tplParams.sealX }} y: {{ tplParams.sealY }}
            </div>
          </div>
          <div class="seal-type__wrapper">
            <div
              :class="{
                'seal-type_normal': true,
                'seal-type_active': tplParams.sealType === 'Single',
              }"
              @click="tplParams.sealType = 'Single'"
            >
              单页签章
            </div>
            <div
              :class="{
                'seal-type_normal': true,
                'seal-type_active': tplParams.sealType === 'Edges',
              }"
              @click="tplParams.sealType = 'Edges'"
            >
              骑缝签章
            </div>
          </div>
          <div
            style="
              font-size: 12px;
              color: #626f79;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 16px;
            "
          >
            指定页码
            <el-input-number
              :disabled="disabled"
              v-model="tplParams.sealPage"
              :min="1"
              size="mini"
              controls-position="right"
            />
          </div>

          <div
            style="
              color: #626f79;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 16px;
              font-size: 12px;
            "
          >
            显示签署日期:
            <el-checkbox :disabled="disabled" v-model="tplParams.hasTime" />
          </div>
          <div style="display: flex; justify-content: flex-end">
            <el-radio-group
              v-if="tplParams.hasTime"
              v-model="tplParams.timeFormat"
              style="display: flex; flex-direction: column"
            >
              <el-radio :label="'YYYY-MM-DD'" style="margin-top: 12px"
                >YYYY-MM-DD</el-radio
              >
              <el-radio :label="'YYYY年MM月DD日'" style="margin-top: 12px"
                >YYYY年MM月DD日</el-radio
              >
              <el-radio :label="'YYYY/MM/DD日'" style="margin-top: 12px"
                >YYYY/MM/DD日</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <template v-if="currentAttachment.name">
      <el-dialog :visible.sync="isShowUpload" :title="currentAttachment.name">
        <div style="text-align: center">
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="downLoadFile(currentAttachment.url)"
            >下载</el-button
          >
          <el-button
            type="success"
            icon="el-icon-tickets"
            @click="previewFile(currentAttachment)"
            >在线预览</el-button
          >
        </div>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import service, { FLOW_DESIGN_URL } from '@/utils/service'
import VueUhtmlWrap from 'vue-ueditor-wrap'
import '../css/print.scss'
import { encrypt } from '../../../utils/crypto'
import { encode } from './base64'
export default {
  components: {
    VueUhtmlWrap
  },
  data () {
    return {
      disabled: false,
      // ueditor配置
      ueditorConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        initialFrameHeight: 500,
        initialFrameWidth: '100%',
        UEDITOR_HOME_URL: process.env.VUE_APP_HOST + '/UEditor/',
        // UEDITOR_SERVER_URL: process.env.VUE_APP_HOST + "/UEditor/",
        serverUrl: '',
        headers: {
          Authorization: ''
        }
      },
      tplParams: {
        isFtl: false,
        isDefault: false,
        name: '',
        accountType: 'Department', // 部门章或者个人章 - 暂时只支持部门章
        stype: 'handler', // 审核人所在部门-handler | 指定部门-dept
        departmentId: '', // 当stype为指定部门时有效
        sealInEditor: false, // 模板是否包含签章
        sealX: '', // 签章到文档左边的距离
        sealY: '', // 签章到文档顶部的距离
        editorScrollTop: '', // editor的滚动距离
        editorWidth: '', // editor宽度
        editorHeight: '',
        editorValue: '', // 模板内容
        sealType: 'Single', // 单页签-Single | 骑缝章-Edges
        sealPage: 1, // 签章页码
        hasTime: false, // 是否需要时间
        timeFormat: '', // 时间格式
        fid: this.$route.params.fid,
        id: '', // 模板id：新增模板id为空
        downloadFileName: '', // ftl文件下载时的名称
        templateName: '' // 自定义模板名称
      },
      sealIntialPos: {
        top: '',
        left: '',
        sealX: '',
        sealY: ''
      },
      departmentData: [],
      filterConditionValue: '',
      placeholderList: [],
      // 内容相关尺寸设置
      placeholderListHeight: '500px',
      pmcHeight: 'auto',
      toolbarHeight: 0,
      bottombarHeight: 0,
      mouseStatus: 'onmouseup',
      saveLoading: false,
      sonPages: {},
      isShowUpload: false,
      action: '',
      headers: {},
      ftlFile: '', // 上传模板文件
      fileList: [],
      currentAttachment: {}
    }
  },
  computed: {
    signImg () {
      return process.env.VUE_APP_SIGNATURE_IMAGE || ''
    },
    placeholderFilterList () {
      const filterArr = this.placeholderList.filter((item) => {
        const str = item.name + '：' + item.model
        return str.indexOf(this.filterConditionValue) > -1
      })
      return filterArr
    },
    baseUrl () {
      // eslint-disable-next-line no-useless-escape
      const index = FLOW_DESIGN_URL.lastIndexOf('/')
      return FLOW_DESIGN_URL.substring(0, index)
    },
    authorization () {
      return 'Bearer ' + localStorage.getItem('Admin-Token')
    }
  },
  created () {
    this.ueditorConfig.serverUrl =
      process.env.VUE_APP_FORM_CENTER_API + '/uu/ueditor'
    this.ueditorConfig.headers.Authorization =
      'Bearer ' + localStorage.getItem('Admin-Token')
    this.tplParams.id = this.$route.query.tplId || ''
    if (this.$route.query.type === 'details') {
      this.disabled = true
    }
    this.getFormJson()
    const appId = this.$route.query.form_id
    const now = new Date()
    const dir = '' + now.getFullYear() + (now.getMonth() + 1) + now.getDate()
    const timeStr = Date.now()
    // 这个timeStr要加到请求头里，在el-upload里有配置headers的 ok？我看下就直接timestr吗对的timeStr要等于加密字段的timeStr，后端请求头里获取到，然后用这个去解密ok
    const fileType = encrypt('', 'formflow' + timeStr)
    this.action = `${
      this.baseUrl
    }/fileService/api/v1/file/service/file-upload/upload?appId=${appId}&dir=${dir}&fileType=${encodeURIComponent(
      fileType
    )}`
    this.headers = {
      authorization: this.authorization,
      timeStr: timeStr
    }
  },
  mounted () {},
  methods: {
    domainURI (str) {
      // eslint-disable-next-line no-useless-escape
      var durl = /http:\/\/([^\/]+)\//i
      let domain = str.match(durl)
      return domain[1]
    },
    move (e) {
      this.mouseStatus = 'onmousedown'
      const odiv = e.target // 获取目标元素
      if (odiv.getAttribute('id') !== 'seal') {
        return
      }
      // 计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
      const x = e.clientX - odiv.offsetLeft
      const y = e.clientY - odiv.offsetTop
      document.onmousemove = (e) => {
        this.mouseStatus = 'onmousemove'
        // 获取拖拽元素的位置
        const left = e.clientX - x
        const top = e.clientY - y
        odiv.style.left = left + 'px'
        odiv.style.top = top + 'px'
      }
      // 为了防止 火狐浏览器 拖拽阴影问题
      document.onmouseup = (e) => {
        this.mouseStatus = 'onmouseup'
        const left = e.clientX - x
        const top = e.clientY - y
        const minX = document.querySelector('.pmc-center').offsetLeft
        const maxX =
          document.querySelector('.pmc-right').offsetLeft - odiv.offsetWidth
        const minY =
          document.querySelector('.pmc-center').offsetTop + this.toolbarHeight
        const maxY =
          document.querySelector('.pmc-center').offsetTop +
          document.querySelector('.pmc-center').offsetHeight -
          odiv.offsetHeight -
          this.bottombarHeight
        // 签章移动如果不在编辑器内则回到原位
        const html = this.editorInstance.document.body.parentNode
        this.tplParams.editorWidth = html.clientWidth
        this.tplParams.editorHeight = html.clientHeight
        if (!(left >= minX && left <= maxX && top >= minY && top <= maxY)) {
          this.resetSeal(odiv)
        } else {
          this.tplParams.sealInEditor = true
          const sealInEditorX = left - minX // 相对于编辑器左边的位置
          const sealInEditorY = top - minY // 相对于编辑器顶部的位置

          this.tplParams.sealX = sealInEditorX + odiv.offsetWidth / 2
          this.tplParams.editorScrollTop = html.scrollTop
          this.tplParams.sealY =
            sealInEditorY +
            this.tplParams.editorScrollTop +
            odiv.offsetWidth / 2
        }
        document.onmousemove = null
        document.onmouseup = null
        document.onmousedown = null
      }
    },
    initSign () {
      this.tplParams.sealInEditor = true
      const html = this.editorInstance.document.body.parentNode
      const minX = document.querySelector('.pmc-center').offsetLeft
      const minY =
        document.querySelector('.pmc-center').offsetTop + this.toolbarHeight
      const odiv = document.querySelector('#seal')
      // 初始化签章坐标
      this.$nextTick((res) => {
        html.scrollTop = this.tplParams.editorScrollTop
        odiv.style.left =
          this.tplParams.sealX - odiv.offsetWidth / 2 + minX + 'px'
        odiv.style.top =
          this.tplParams.sealY -
          this.tplParams.editorScrollTop -
          odiv.offsetWidth / 2 +
          minY +
          'px'
      })
      this.sealIntialPos.left =
        this.tplParams.sealX - odiv.offsetWidth / 2 + minX
      this.sealIntialPos.top =
        this.tplParams.sealY -
        this.tplParams.editorScrollTop -
        odiv.offsetWidth / 2 +
        minY
      this.sealIntialPos.sealX = this.tplParams.sealX
      this.sealIntialPos.sealY = this.tplParams.sealY
    },
    resetSeal () {
      setTimeout(() => {
        if (!this.sealIntialPos.sealX) {
          this.tplParams.sealInEditor = false
        }
        const odiv = document.getElementById('seal')
        odiv.style.left = this.sealIntialPos.left + 'px'
        odiv.style.top = this.sealIntialPos.top + 'px'
        this.tplParams.sealX = this.sealIntialPos.sealX
        this.tplParams.sealY = this.sealIntialPos.sealY
      }, 0)
    },
    getSignTpl () {
      service
        .get(`/uu/signature/getSignatureInfoById?id=${this.tplParams.id}`)
        .then((res) => {
          this.tplParams.editorValue = res.data.html
          this.tplParams.isFtl = res.data.isFtl === 'true'
          this.tplParams.templateName = res.data.templateName
          this.ftlFile = res.data.ftlFile
          this.fileList = [
            {
              name: `${res.data.name}`,
              url: res.data.ftlFile
            }
          ]
          this.tplParams.isDefault = res.data.isDefaultTpl === 'true'
          this.tplParams.accountType = res.data.accountType
          this.tplParams.name = res.data.name
          this.tplParams.stype = res.data.stype
          if (this.tplParams.stype === 'dept') {
            this.tplParams.departmentId = this.getRelativeDepId(
              res.data.departmentId
            )
          }
          this.tplParams.sealX = res.data.px
          this.tplParams.sealY = res.data.py
          this.tplParams.editorScrollTop = parseInt(res.data.editorScrollTop)
          this.tplParams.hasTime = res.data.hasTime === 'true'
          if (this.tplParams.hasTime) {
            this.tplParams.timeFormat = res.data.timeTpl
          }
          this.tplParams.sealPage = res.data.posPage
          this.tplParams.sealType = res.data.posType
          if (res.data.px && res.data.py) {
            this.initSign()
          }
        })
    },
    editorReady (editorInstance) {
      setTimeout(() => {
        this.pmcHeight =
          this.$refs.printMain.offsetHeight -
          this.$refs.pmHeader.offsetHeight +
          'px'
        this.placeholderListHeight =
          parseInt(this.pmcHeight) -
          this.$refs.pmclFilter.$el.offsetHeight -
          20 +
          'px'
        this.editorInstance = editorInstance
        const containerChilds = editorInstance.container.children
        for (let i = 0; i < containerChilds.length; i++) {
          if (containerChilds[i].id.indexOf('toolbarbox') > -1) {
            this.toolbarHeight = containerChilds[i].offsetHeight
          }
          if (containerChilds[i].id.indexOf('bottombar') > -1) {
            this.bottombarHeight = containerChilds[i].offsetHeight
          }
        }
        this.ueditorConfig.initialFrameHeight =
          this.$refs.pmCenter.offsetHeight -
          this.toolbarHeight -
          this.bottombarHeight
        this.editorInstance.setHeight(this.ueditorConfig.initialFrameHeight)
        this.placeholderListHeight =
          document.querySelector('.print-main').offsetHeight -
          document.querySelector('.pm-header').offsetHeight
        // 获取超出位置时候重置签章的位置
        const sealStaticPositon = document
          .querySelector('#seal-static')
          .getBoundingClientRect()
        this.sealIntialPos.left = sealStaticPositon.left - 50
        this.sealIntialPos.top = sealStaticPositon.top
        this.getInstitution()
        if (this.disabled) {
          editorInstance.setDisabled()
        }
      })
    },
    goDesign () {
      this.$router.push({
        path: '/workbench/' + this.$route.params.fid + '/design',
        query: {
          form_id: this.$route.query.form_id,
          yyid: this.$route.query.yyid,
          from_router: 'print'
        }
      })
    },
    // 通过表单模板数据获取相应占位变量
    getInputModel (list, columns) {
      if (list && list.length) {
        list.forEach((item) => {
          this.placeholderList.push({
            name: item.name,
            model: '${' + item.model + '}'
          })
          if (item.type === 'page') {
            const page = this.sonPages[item.options.selectPage]
            if (page) {
              this.getInputModel(page.list, page.columns)
            }
          } else if (item.type === 'sonform') {
            this.getInputModel(item.list, item.columns)
          } else if (item.type === 'grid') {
            this.getInputModel(item.list, item.columns)
          } else if (item.type === 'comment') {
            this.getInputModel(item.list, item.columns)
          }
        })
      }
      if (columns && columns.length) {
        columns.forEach((item) => {
          this.getInputModel(item.list, item.columns)
        })
      }
    },
    // 获取组织机构数据
    getInstitution () {
      service.get('/v1/institution/getInstitutionTreeData').then((res) => {
        this.departmentData = res
        // 初始化位置
        if (this.$route.query.type !== 'add') {
          this.getSignTpl()
        }
      })
    },
    // 获取表单数据
    getFormJson () {
      service
        .get(`/v1/formflow/getNewFormInfoByFid?fid=${this.$route.params.fid}`)
        .then((res) => {
          if (res.moduleJson) {
            this.sonPages = res.moduleJson.sonPages
            this.placeholderList.push({
              name: '流水号',
              // eslint-disable-next-line no-template-curly-in-string
              model: '${serial_number}'
            })
            this.getInputModel(res.moduleJson.list)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    saveTpl () {
      if (this.tplParams.id) {
        this.updateTpl()
        return
      }
      if (!this.tplParams.name) {
        this.$swMessage.warning('请输入模板名称')
        return
      }
      if (
        this.tplParams.sealInEditor &&
        this.tplParams.stype === 'dept' &&
        this.tplParams.departmentId === ''
      ) {
        this.$swMessage.warning('请选择部门名称')
        return
      }
      this.saveLoading = true
      service
        .post('/uu/signature/addSignatureTpl', {
          accountType: this.tplParams.accountType, // 暂定写死部门章
          isFtl: this.tplParams.isFtl, // 是否为ftl打印
          templateName: this.tplParams.templateName, // 自定义模板名称
          ftlFile: this.ftlFile, // 上传模板文件
          downloadFileName: this.tplParams.downloadFileName,
          isDefaultTpl: this.tplParams.isDefault, // 是否为默认模板
          departmentId: this.getSingleDepId(this.tplParams.departmentId),
          px: this.tplParams.sealX,
          py: this.tplParams.sealY,
          editorScrollTop: this.tplParams.editorScrollTop,
          htmlW: this.tplParams.editorWidth,
          htmlH: this.tplParams.editorHeight,
          posPage: this.tplParams.sealPage,
          posType: this.tplParams.sealType, // Single 单页签 Edges 骑缝签
          name: this.tplParams.name,
          stype: this.tplParams.stype, // 审核人部门还是指定部门
          hasTime: this.tplParams.hasTime,
          timeTpl: this.tplParams.timeFormat,
          fid: this.$route.params.fid,
          html: this.tplParams.editorValue
        })
        .then((res) => {
          this.$swMessage.success(res.msg)
        })
        .catch((err) => {
          this.$swMessage.error(err)
        })
        .finally((res) => {
          this.saveLoading = false
        })
    },
    updateTpl () {
      if (!this.tplParams.name) {
        this.$swMessage.warning('请输入模板名称')
        return
      }
      if (
        this.tplParams.sealInEditor &&
        this.tplParams.stype === 'dept' &&
        this.tplParams.departmentId === ''
      ) {
        this.$swMessage.warning('请选择部门名称')
        return
      }
      this.saveLoading = true
      service
        .post('/uu/signature/updateSignatureTpl', {
          accountType: this.tplParams.accountType, // 暂定写死部门章
          isFtl: this.tplParams.isFtl, // 是否为ftl打印
          templateName: this.tplParams.templateName, // 自定义模板名称
          ftlFile: this.ftlFile, // 上传模板文件
          isDefaultTpl: this.tplParams.isDefault + '', // 是否为默认模板
          departmentId: this.getSingleDepId(this.tplParams.departmentId),
          px: this.tplParams.sealX,
          py: this.tplParams.sealY,
          editorScrollTop: this.tplParams.editorScrollTop,
          htmlW: this.tplParams.editorWidth,
          htmlH: this.tplParams.editorHeight,
          posPage: this.tplParams.sealPage,
          posType: this.tplParams.sealType, // Single 单页签 Edges 骑缝签
          name: this.tplParams.name,
          stype: this.tplParams.stype, // 审核人部门还是指定部门
          hasTime: this.tplParams.hasTime + '',
          timeTpl: this.tplParams.timeFormat,
          fid: this.$route.params.fid,
          html: this.tplParams.editorValue,
          id: this.tplParams.id
        })
        .then((res) => {
          this.$swMessage.success(res.msg)
        })
        .finally((res) => {
          this.saveLoading = false
        })
    },
    getSingleDepId (arr) {
      if (arr && arr.length) {
        arr = arr.reverse()
        return arr[0]
      } else {
        return ''
      }
    },
    getRelativeDepId (depId) {
      return this.treeFindPath(
        this.departmentData,
        (data) => data.id === depId
      )
    },
    treeFindPath (tree, func, path = []) {
      if (!tree) return []
      for (const data of tree) {
        path.push(data.id)
        if (func(data)) return path
        if (data.children) {
          const findChildren = this.treeFindPath(data.children, func, path)
          if (findChildren.length) return findChildren
        }
        path.pop()
      }
      return []
    },
    beforeFileUpload (file) {
      // const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      // const isXml = suffix === 'xml'

      // if (!isXml) {
      //   this.$message.error('模板上传只允许 xml 格式!')
      // }
      return true
    },
    handleFileSuccess (res, file, fileList) {
      // console.log('res', res, file, fileList)
      this.$swMessage({
        message: `上传成功`,
        type: 'success'
      })
      this.isShowUpload = false
      this.tplParams.name = file.name.substring(0, file.name.lastIndexOf('.'))
      this.ftlFile = `${this.baseUrl}/fileService/api/v1/file/service/file-upload/download?id=${res.data.id}`
      this.fileList = fileList.map((file) => {
        if (file.response) {
          file.url = `${this.baseUrl}/fileService/api/v1/file/service/file-upload/download?id=${file.response.data.id}`
        }

        return file
      })
      // this.fileList.shift();
    },
    handleFileError (error) {
      this.$swMessage.error(error)
    },
    handleFileChange (file) {
      this.currentAttachment = file
      this.isShowUpload = true
    },
    downLoadFile (url) {
      location.href = url
    },
    previewFile (file) {
      var previewUrl = file.url + '&fullfilename=' + file.name
      console.log(previewUrl)
      const link = `${process.env.VUE_APP_PREVIEW}?url=${encodeURIComponent(
        encode(previewUrl)
      )}`
      window.open(link)
    }
  }
}
</script>
<style lang="scss" scoped>
.ff_print_tpl {
  .td-header {
    box-sizing: border-box;
    height: auto !important;
    padding: 5px 20px 0;
    display: flex;
    justify-content: space-between;
    .tdh-left {
      display: flex;
      justify-content: center;
      align-items: center;
      .tdhl-rect-icon {
        margin-right: 4px;
        width: 3px;
        height: 12px;
        background: linear-gradient(
          177deg,
          rgba(97, 193, 190, 1) 0%,
          rgba(51, 148, 225, 1) 100%
        );
      }
      .tdhl-title {
        cursor: pointer;
        margin-right: 4px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(98, 111, 121, 1);
        line-height: 20px;
      }
      .tdhl-arrow-icon {
        margin-right: 4px;
        transform: rotate(-90deg);
        font-size: 12px;
        color: #bec9d2;
      }
      .tdhl-subtitle {
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(39, 56, 70, 1);
        line-height: 20px;
      }
    }
    .tdh-right {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #314250;
      border-bottom: 1px solid transparent;
      &:hover {
        border-bottom: 1px solid #314250;
      }
    }
  }
  ::v-deep.el-switch__label,
  .el-switch__label.is-active {
    color: #606266;
  }
  ::v-deep.el-dialog__header {
    text-align: center;
  }
  .print-main {
    .pmc-ftl {
      margin-top: 10px;
      .el-button--small {
        padding: 9px 8px;
      }
    }
  }
}
</style>
